"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getLoaderOptions", {
  enumerable: true,
  get: function get() {
    return _optionUtils.getGlobalLoaderOptions;
  }
});
Object.defineProperty(exports, "setLoaderOptions", {
  enumerable: true,
  get: function get() {
    return _optionUtils.setGlobalOptions;
  }
});
var _optionUtils = require("../loader-utils/option-utils");
//# sourceMappingURL=loader-options.js.map